export const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 270 138" preserveAspectRatio="xMidYMid meet">
  <path
    d="M133.23,0h0s-102.32,0-102.32,0C13.84,0,0,13.84,0,30.91v102.32h133.23s102.32,0,102.32,0c17.07,0,30.91-13.84,30.91-30.91V0h-133.23ZM127.3,127.3H5.93V31.26c0-13.99,11.34-25.33,25.33-25.33h96.04v121.37Z"
    fill="{{HEADER_LINKS_COLOR}}"
  />
  <text
    x="35"
    y="105"
    fill="{{HEADER_LINKS_COLOR}}"
    font-family="Barlow-ExtraBold, Barlow, Inter, system-ui, sans-serif"
    font-size="100"
    font-weight="800"
  >{{LOGO_INITIAL_1}}</text>
  <text
    x="160"
    y="105"
    fill="{{HEADER_BACKGROUND}}"
    font-family="Barlow-ExtraBold, Barlow, Inter, system-ui, sans-serif"
    font-size="100"
    font-weight="800"
  >{{LOGO_INITIAL_2}}</text>
</svg>
`;
